import { Link, useNavigate } from "react-router-dom"
import { ChevronRight } from "lucide-react"
import { numberToUSD } from "../../../utils"
import Cell from "../cell"
import ScreenReaderOnly from "../../screen-reader-only"
import HeaderCell from "../header-cell"
import HeaderRow from "../header-row"
import { BillingLog, BillingLogs } from "../../../../types"
import { DateTime } from "luxon"

interface Props {
  orgId: string | number
  systemUsage: BillingLogs
  invoicePath?: string
}

const InvoicesTable = ({
  orgId,
  systemUsage,
  invoicePath = "billing"
}: Props) => {
  const navigate = useNavigate()

  const onClickRow = (item: BillingLog) => {
    const options = {
      state: {
        usage: item
      }
    }
    navigate(`/${invoicePath}/${item.id}`, options)
  }

  const getInvoiceDate = (invoiceTimestamp: number) => {
    const luxonTime = DateTime.fromSeconds(Number(invoiceTimestamp), {
      zone: "utc"
    })
    return luxonTime.toLocaleString()
  }

  return (
    <div className="bg-white md:px-8 py-6 md:py-12 rounded-lg">
      <table className="w-full border-collapse table-auto text-left">
        <thead>
          <HeaderRow>
            <HeaderCell>Date</HeaderCell>
            <HeaderCell className="hidden md:table-cell">
              Leads count
            </HeaderCell>
            <HeaderCell className="hidden md:table-cell">Emails</HeaderCell>
            <HeaderCell className="hidden md:table-cell">SMS</HeaderCell>
            <HeaderCell className="whitespace-nowrap">
              Invoice amount
            </HeaderCell>
            <HeaderCell>
              <ScreenReaderOnly>invoice link</ScreenReaderOnly>
            </HeaderCell>
          </HeaderRow>
        </thead>
        <tbody className="divide-y divide-zinc-200">
          {systemUsage.map((item, i) => {
            const { breakdown, total } = item?.details
            const timestamp = item?.timestamp
            return (
              <tr
                key={orgId}
                onClick={() => onClickRow(item)}
                className="cursor-pointer"
              >
                <Cell>{getInvoiceDate(timestamp)}</Cell>
                <Cell className="hidden md:table-cell">
                  {breakdown?.leads?.total ?? 0}
                </Cell>
                <Cell className="hidden md:table-cell">
                  {breakdown?.emails?.total ?? 0}
                </Cell>
                <Cell className="hidden md:table-cell">
                  {breakdown?.sms?.total ?? 0}
                </Cell>
                <Cell>{numberToUSD(total ?? 0)}</Cell>
                <Cell>
                  <Link to={`/${invoicePath}/${orgId}`}>
                    <ChevronRight size={16} />
                    <ScreenReaderOnly>View invoice</ScreenReaderOnly>
                  </Link>
                </Cell>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default InvoicesTable
